import { Box, Button, Card, Typography } from "@mui/material"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom";
import userService from "services/userService";

export const UserMinimal: React.FC<{ userId: string, discussionId: number }> = ({ userId, discussionId }) => {
    const navigate = useNavigate();

    const viewProfile = () => {
        navigate(`/user/${userId}`);
    }

    return <Card>
        <Box m={1}>
            <Button onClick={() => viewProfile()}>
                Voir le profil
            </Button>
        </Box>
    </Card>
}